
import PlaceholderGrimoie from '../images/missing_grimoire.png';
import PlaceholderEntry from '../images/missing_entry.png';
import PlaceholderItem from '../images/missing_item.png';

type Props = {
    src: string | undefined,
    alt: string,
    image_type: string
}

const ImageWithFallBack = (props: Props) => {

    if(props.image_type === "Grimoire") {
        return (
            <img
                src={props.src !== "" ? props.src : PlaceholderGrimoie}
                alt={props.alt}
                loading="lazy"
                className="image-doomscroll"
                onError={(e) => e.currentTarget.src = PlaceholderGrimoie}
            />
        );
    }
    else if(props.image_type === "Lore Entry" || props.image_type === "Lore Book") {
        return (
            <img
                src={props.src !== "" ? props.src : PlaceholderEntry}
                alt={props.alt}
                loading='eager'
                className="image-doomscroll"
                onError={(e) => e.currentTarget.src = PlaceholderEntry}
            />
        );
    }
    else if(props.image_type === "Item" || props.image_type.includes("Quest")) {
        return (
            <img
                src={props.src !== "" ? props.src : PlaceholderItem}
                alt={props.alt}
                loading='eager'
                className="image-doomscroll"
                onError={(e) => e.currentTarget.src = PlaceholderItem}
            />
        );
    }
    else if(props.image_type === "Release") {
        return (
            <img
                src={props.src !== "" ? props.src : ""}
                alt={props.alt}
                loading='eager'
                className="image-doomscroll"
                onError={(e) => e.currentTarget.src = ""}
            />
        );
    }
    else if(props.image_type === "Placeholder Item") {
        return (
            <img
                src={PlaceholderItem}
                alt={props.alt}
                loading='eager'
                className="image-doomscroll"
                onError={(e) => e.currentTarget.src = PlaceholderItem}
            />
        );
    }
    else {
        return (
            <img
                src={props.src !== "" ? props.src : PlaceholderItem}
                alt={props.alt}
                loading='eager'                
                onError={(e) => e.currentTarget.src = PlaceholderItem}
            />
        );
    }
}
export default ImageWithFallBack;